import { timestamp, uuid } from "@/interfaces";

export enum property_types {
  luxury = "luxury",
  leaseup = "leaseup",
  affordable = "affordable",
  senior = "senior",
  student = "student",
}

export enum property_structures {
  highrise = "highrise",
  midrise = "midrise",
  "garden style" = "garden style",
  historic = "historic",
  botique = "botique",
  others = "others",
}

export enum property_classes {
  A = "A",
  B = "B",
  C = "C",
}

export interface Property {
  id: uuid;
  name: string;
  image: string | File;
  slug: string;
  address: string;
  street: string;
  city: string;
  county: string;
  state: string;
  zip: string;
  latitude: number;
  longitude: number;
  description: string;
  website: string;
  meta_data: object; // TBD
  type: property_types[];
  structure: property_structures[];
  class: property_classes[];
  organization: uuid;
  year_built: number;
  floors: number;
  bill_to_name: string;
  bill_to_address: string;
  created_at: timestamp;
  updated_at: timestamp;
  deleted_at: timestamp | null;
}

export interface PropertyUnit {
  id: uuid;
  unit_number: string;
  floor_plan: string;
  beds: number;
  baths: number;
  property: uuid;
  created_at: timestamp;
  updated_at: timestamp;
}

export interface PropertyUserMetadata {
  role?: string;
  notes?: string;
}
